module.exports = "<div id=\"app\">\r\n        <router-outlet></router-outlet>\r\n</div>\r\n"